export default __webpack_public_path__ + "graphik-light.woff";